export {
	Stepper,
	StepperDescription,
	StepperIndicator,
	StepperSeparator,
	StepperTitle,
	StepperTrigger,
} from "ics-ui-kit/components/stepper";
export { StepperItem } from "./StepperItem";
